export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="w-full bg-background-950 border-t border-background-800">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); scrollTo('hero'); }}
            className="cursor-pointer"
          >
            <span className="font-heading text-3xl text-accent-500 glow-text">D'CURE GELATO &amp; BAKERY</span>
          </a>

          <div className="flex items-center gap-8 flex-wrap justify-center">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); scrollTo('hero'); }}
              className="font-label text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Home
            </a>
            <a
              href="#about"
              onClick={(e) => { e.preventDefault(); scrollTo('about'); }}
              className="font-label text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              About
            </a>
            <a
              href="#products"
              onClick={(e) => { e.preventDefault(); scrollTo('products'); }}
              className="font-label text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Products
            </a>
            <a
              href="#menu"
              onClick={(e) => { e.preventDefault(); scrollTo('menu'); }}
              className="font-label text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Menu
            </a>
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}
              className="font-label text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact
            </a>
          </div>

          <div className="flex items-center gap-4">
            <a href="https://www.tiktok.com/@dcure.gelato.bake" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-all cursor-pointer">
              <i className="ri-tiktok-fill text-sm"></i>
            </a>
            <a href="https://www.instagram.com/dcuregelatomelaka/?hl=en" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-all cursor-pointer">
              <i className="ri-instagram-line text-sm"></i>
            </a>
            <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:bg-background-700 transition-all cursor-pointer">
              <i className="ri-facebook-fill text-sm"></i>
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-label text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} D'CURE Gelato. All rights reserved.
          </p>
          <p className="font-label text-xs text-foreground-500">
            63, Jalan Kampung Pantai, 75200 Melaka, Malaysia
          </p>
        </div>
      </div>
    </footer>
  );
}